export const certificates = [
  {
    id: 'cert-001',
    dogName: 'Max',
    certificateType: 'Buena conducta',
    dateIssued: '2023-05-15',
    image: 'https://images.unsplash.com/photo-1586671267731-da2cf3ceeb80?w=200',
    userId: 'user-001'
  },
  {
    id: 'cert-002',
    dogName: 'Luna',
    certificateType: 'Socialización',
    dateIssued: '2023-04-20',
    image: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=200',
    userId: 'user-002'
  },
  {
    id: 'cert-003',
    dogName: 'Rocky',
    certificateType: 'Paseo extremo',
    dateIssued: '2023-06-10',
    image: 'https://images.unsplash.com/photo-1583337130417-3346a1be7dee?w=200',
    userId: 'user-001'
  }
];

export const users = [
  { id: 'user-001', name: 'Juan Pérez' },
  { id: 'user-002', name: 'María Gómez' }
];